export enum PopupPlacement {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right'
}

export interface PopupData {
    content: string;
    nextButtonText: string;
    progressText: string;
    placement: PopupPlacement;
    closeButtonAriaLabel?: string;
    nextButtonAriaLabel?: string;
}
